module.exports = __webpack_public_path__ + "img/zw.72e67b6b.png";